import Vue from 'vue';
import { format } from 'date-fns';
import {
  cs, enGB, de, nl, pl, sk, es,
} from 'date-fns/locale';

const locales = {
  cs,
  en: enGB,
  de,
  nl,
  pl,
  sk,
  es,
};

export default Vue.filter('formatDay', (value, locale) => {
  if (value) {
    const selectedLocale = locales[locale] || locales.cs;
    return format(new Date(value), 'EEEE', { locale: selectedLocale });
  }
  return '';
});
